import {BOOK_CREATED, BOOKLIST_CREATED, BOOKLISTS_FETCHED, BOOKS_FETCHED, SET_CURRENT_PAGE} from "../../../types";
import api from "../../../api";

export const bookCreated = (data) => ({
    type: BOOK_CREATED,
    data
})
export const bookListCreated = (data) => ({
    type: BOOKLIST_CREATED,
    data
})

export const changePageD = (data) => ({
    type: SET_CURRENT_PAGE,
    data
})

export const books_fetched = (data) => ({
    type: BOOKS_FETCHED,
    data
})
export const booklists_fetched = (data) => ({
    type: BOOKLISTS_FETCHED,
    data
})

export const chRecViewed = (data) => dispatch => 
    api.books.chRecViewed(data).then(msg => 
        dispatch(bookCreated({status: msg.status}))
    );

export const chBlRecViewed = (data) => dispatch => 
    api.books.chBlRecViewed(data).then(msg => 
        dispatch(bookListCreated({status: msg.status}))
    );

export const createBook = (data) => dispatch => 
    api.books.createBook(data).then(msg => 
        dispatch(bookCreated({status: msg.status}))
    );

export const createBookList = (data) => dispatch => 
    api.books.createBookList(data).then(msg => 
        dispatch(bookListCreated({status: msg.status}))
    );

export const deleteBook = (data) => dispatch => 
    api.books.deleteBook(data).then(msg => 
        dispatch(bookCreated({status: msg.status}))
    );

export const deleteBookl = (data) => dispatch => 
    api.books.deleteBookl(data).then(msg => 
        dispatch(bookListCreated({status: msg.status}))
    );

export const addToBookList = (data) => dispatch => 
    api.books.addToBookList(data).then(msg => 
        dispatch(bookListCreated({status: msg.status}))
    );

export const removeBookList = (data) => dispatch => 
    api.books.removeBookList(data).then(msg => 
        dispatch(bookListCreated({status: msg.status}))
    );

export const uploadBookCover = (data) => dispatch => 
    api.books.uploadBookCover(data).then(msg => 
        dispatch(bookCreated(msg))
    );

export const uploadBookFile = (data) => dispatch => 
    api.books.uploadBookFile(data).then(msg => 
        dispatch(bookCreated(msg))
    );

export const chPag = (data) => dispatch => 
    api.books.chPag(data).then(data => 
        console.log('OK')
    );
export const chCha = (data) => dispatch => 
    api.books.chCha(data).then(data => 
        console.log('OK')
    );

export const fetch_books = () => dispatch => 
    api.books.fetch_books().then(data => 
        dispatch(books_fetched(data))
    );
export const fetch_booklists = () => dispatch => 
    api.books.fetch_booklists().then(data => 
        dispatch(booklists_fetched(data))
    );

export const fetch_a_book = (data) => dispatch => 
    api.books.fetch_a_book(data).then(data => 
        dispatch(bookCreated(data))
    );

export const chBookTitle = (data) => dispatch => 
    api.books.chBookTitle(data).then(data => 
        dispatch(bookCreated(data))
    );

export const chBooklTitle = (data) => dispatch => 
    api.books.chBooklTitle(data).then(data => 
        dispatch(bookListCreated(data))
    );

export const chBooklDescription = (data) => dispatch => 
    api.books.chBooklDescription(data).then(data => 
        dispatch(bookListCreated(data))
    );

export const chBookDescription = (data) => dispatch => 
    api.books.chBookDescription(data).then(data => 
        dispatch(bookCreated(data))
    );

export const changePage = (data) => dispatch => 
    dispatch(changePageD(data))